import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const SubsidyOverview = ({ scheme }) => (
  <section className="py-16">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2">
          <h2 className="font-heading text-2xl font-semibold text-[#0f172a] mb-4">Overview</h2>
          <p className="text-[#64748b] leading-relaxed text-lg">{scheme.overview}</p>
        </div>
        <div>
          <Card className="border border-slate-100 sticky top-24">
            <CardHeader>
              <CardTitle className="font-heading text-lg">Quick Consultation</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-[#64748b] mb-4">
                Need help understanding this scheme? Our experts can guide you.
              </p>
              <Link
                to="/contact"
                className={`w-full gradient-btn px-6 py-3 rounded-full font-medium text-white inline-flex items-center justify-center gap-2`}
              >
                Get Expert Help
                <ArrowRight size={16} />
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </section>
);
